import { defineAction } from '~/prix'
import { z } from 'zod'
import veterinaryExamFetchAction from './veterinaryExamFetch.action.json' with { type: 'json' }
import { veterinaryExamObject } from '../veterinaryExamObject'

const veterinaryExamFetchDefinition = defineAction({
  ...veterinaryExamFetchAction,

  input: z.object({
    id: z.string().uuid(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: veterinaryExamObject,
})

export default veterinaryExamFetchDefinition
